import { css } from 'linaria';

export const fadeButton = css`
  --translate-distance: 0 !important;
  position: absolute;
  top: unset;
  left: 0;
  bottom: 0;
  z-index: 1;
  min-width: 112px;
  min-height: 40px;
  background-color: var(--control-minor);
  border: none;
  border-radius: 120px;
  box-shadow: var(--box-shadow-m);
  @media (--to-tablet) {
    left: var(--space-200);
  }
`;

export const openButton = css`
  position: relative !important;
`;
